import Vue from 'vue'
import utilsjs from '@/utils';
import axios from '@/host/http.js';
import axiosAjax from '@/host/axiosAjax.js';

// 将axios挂载到prototype上，在组件中可以直接使用this.axios访问
Vue.prototype.axios = axios;
Vue.prototype.axiosAjax = axiosAjax;// 封装公用API；
Vue.prototype.globaljs = utilsjs;// 挂载到vue实例中；



// WEBPACK FOOTER //
// ./src/config/main/vueAddprototype.js